module.exports = __webpack_public_path__ + "img/huellas_de_concreto.6dcba3bb.png";